<template>
  <div>
    <div class="hermes-text-field-with-icon">
      <input
        type="text"
        name="freeTextSearchText"
        v-model="freeTextSearch"
        class="form-control hermes-search-text-field"
        :placeholder="$t('commons.free_text_search_format')"
      />
      <i class="fa fa-search fa-lg fa-fw" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
import { useSearch } from "../../stores/search";
export default {
  computed: {
    freeTextSearch: {
      get() {
        return this.useSearch.freeTextSearch.text;
      },
      set(text) {
        this.useSearch.setFreeTextSearch(text);
      }
    }
  },
  data() {
    return {
      useSearch: useSearch()
    }
  },
};
</script>
